// extracted by mini-css-extract-plugin
export default {"label":"navigation_label__ubnZK","bottomNav":"navigation_bottomNav__B1Zgw"};